<app-theme-option [categories]="themeOptions.optionsConfiguration[optionType].categories" [label]="themeOptions.optionsConfiguration[optionType].label">
  <div app-theme-option-content>
    <app-theme-option-font-family [color]="color" [fontFamily]="themeOptions.options().tooltips.bodyFontFamily" (sendFontFamily)="receiveValue($event)"></app-theme-option-font-family>
  </div>
</app-theme-option>